<script setup lang="ts">
import PreferencesTab from '@/components/account/PreferencesTab.vue';

definePage({
  name: 'account-preferences',
});
</script>

<template>
  <div class="account-container p-6">
    <h2 class="text-2xl font-bold mb-6 text-gray-900">
      Preferences Settings
    </h2>

    <PreferencesTab />
  </div>
</template>

<style scoped>
.account-container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
